import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import resourcesToBackend from 'i18next-resources-to-backend'
import { initReactI18next } from 'react-i18next'

import env from './core/env'

const isDevelopment = env.MODE === 'development' || env.ENV === 'local'

i18n
  .use(resourcesToBackend((lng: string, ns: string) => import(`./locales/${lng}/${ns}.json`)))
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en-US',
    supportedLngs: ['en-US', 'ja-JP', 'es-ES'],

    debug: isDevelopment,
    saveMissing: isDevelopment,

    missingKeyHandler: (lng, ns, key, fallbackValue) => {
      console.warn(
        `Missing translation key: "${key}" for language: "${lng}" in namespace: "${ns}"`,
        isDevelopment ? { language: lng, namespace: ns, key, fallbackValue } : '',
      )
    },

    interpolation: {
      escapeValue: false,
    },

    ns: ['common', 'author', 'folders', 'legacy'],

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    react: {
      useSuspense: false,
    },

    returnNull: false,
    returnEmptyString: false,
    returnObjects: false,

    load: 'currentOnly',
    cleanCode: false,
    initImmediate: false,

    defaultNS: 'common',
    fallbackNS: 'common',
  })

export default i18n
